import { Component, Input, ViewChild } from '@angular/core';
import { _AbcGridColumn, _AbcGridComponent } from '@barthauer/abc/ui-components';
import { DataSource, ArrayStore } from 'devextreme/common/data';
import { SelectionChangedEvent } from 'devextreme/ui/data_grid';
import { ObjectSelectionItem, ObjectsSet } from './models/objects-set';
import { ObjectsSetsService } from './objects-sets.service';

@Component({
    selector: 'object-selection-items',
    template: `<abc-grid
    class="objectSetsNestedGrid"
    #objectSelectionItemsGrid
    [setupDefaultLayoutOnInitialization]="true"
    [columns]="this.columnsEntities"
    [height]="'100%'"
    [selection]="{ mode: 'multiple', selectAllMode: 'allPages', showCheckBoxesMode: 'always' }"
    (onSelectionChanged)="onSelectionChanged($event)"
    [loadPanel]="{ enabled: true }"
  >
    <dxo-group-panel [visible]="true"></dxo-group-panel>
    <dxo-scrolling mode="virtual" showScrollbar="onHover"></dxo-scrolling>
    <dxo-grouping #expand [autoExpandAll]="false"></dxo-grouping>
    <dxo-summary>
      <dxi-group-item column="ObjectType_DisplayText" summaryType="count"> </dxi-group-item>
    </dxo-summary>
  </abc-grid>`,
    standalone: false
})
export class ObjectSelectionItemsComponent {
  @ViewChild('objectSelectionItemsGrid', { static: true }) objectSelectionItemsGrid: _AbcGridComponent;
  @Input() set objectsSet(value: ObjectsSet) {
    this.setDataSource(value);
  }

  public columnsEntities: _AbcGridColumn[] = [
    {
      dataField: 'ObjectType_DisplayText',
      caption: 'Typ',
      groupIndex: 0,
    },
    {
      dataField: 'Id_DisplayText',
      caption: 'Objekt',
    },
    {
      dataField: 'Id',
      caption: 'Id',
      visible: false,
    },
  ];

  constructor(private objectsSetsService: ObjectsSetsService) {}

  public onSelectionChanged(e: SelectionChangedEvent<ObjectSelectionItem, string>) {
    const selectedRowsData: ObjectSelectionItem[] = e.selectedRowsData;
    for (let index = 0; index < selectedRowsData.length; index++) {
      const selectedRowData = selectedRowsData[index];
      this.objectsSetsService.selectedEntities.entities.push(selectedRowData);
    }
  }

  private async setDataSource(objectsSet: ObjectsSet) {
    this.objectSelectionItemsGrid.dataSource = new DataSource(
      new ArrayStore({
        key: 'Id',
        data: await objectsSet.entities(),
      })
    );
  }
}
